import React, { FC } from 'react';
import { Button } from '@mui/material';
import { LabAction } from 'models/action';
import { useTranslation } from 'react-i18next';
import EditActionForm from './edit-action-form.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

const FORM_ID = 'edit-action-form';

type EditActionDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    categories: { _id: string; name: string }[];
    groups: { _id: string; name: string }[];
    actionToEdit: LabAction;
    onEditAction: () => void;
};
const EditActionDialog: FC<EditActionDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    categories,
    groups,
    actionToEdit,
    onEditAction,
}: EditActionDialogProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    return (
        <DHDialog
            title={translate('orders:EDIT_ACTION')}
            maxWidth="md"
            fullWidth
            open={dialogOpen}
            onClose={onCloseDialog}
            actions={
                <Button variant="contained" form={FORM_ID} type="submit">
                    {translate('common:SAVE')}
                </Button>
            }
        >
            <EditActionForm
                formId={FORM_ID}
                onCloseDialog={onCloseDialog}
                categories={categories}
                groups={groups}
                actionToEdit={actionToEdit}
                onEditAction={onEditAction}
            />
        </DHDialog>
    );
};

export default EditActionDialog;
